module.exports = function(bootstrap) {
    bootstrap.factory('spendingAccountService', ['$q', 'services',
        function($q, services) {

            var
                _parseAmountResponse,
                _parseGlanceResponse,
                getAmountAndGlance,
                getAllAmountsAndGlances,
                getSpendingAccount,
                hasSpendingAccount,
                getSpendingAccountList;

            _parseAmountResponse = function(amountData) {
                var
                    amount = {},
                    baseMessage = amountData.baseMessage || {},
                    payloadData = amountData.payload && amountData.payload.repGetClaimAmountData || {};

                amount.username = baseMessage.username || '';
                amount.uuid = baseMessage.uuid || '';
                amount.messages = baseMessage.statusMsgs && baseMessage.statusMsgs.messages || [];
                amount.accountList = payloadData.accountList || {};
                amount.accountListCount = payloadData.accountListCount || '';
                amount.errorText = payloadData.errorText || '';
                amount.returnCode = payloadData.returnCode || '';

                return amount;
            };

            _parseGlanceResponse = function(glanceData) {
                var
                    glance = {},
                    baseMessage = glanceData.baseMessage || {},
                    payloadData = glanceData.payload && glanceData.payload.repGetAccountsAtAGlanceData || {};

                glance.username = baseMessage.username || '';
                glance.uuid = baseMessage.uuid || '';
                glance.returnCode = baseMessage.returnCode || '';
                glance.exchangeType = baseMessage.exchangeType || '';
                glance.messages = baseMessage.statusMsgs && baseMessage.statusMsgs.messages || [];
                glance.accountList = payloadData.accountList || {};
                glance.accountListCount = payloadData.accountListCount || '';
                glance.groupCode = payloadData.groupCode || '';
                glance.participantCode = payloadData.participantCode || '';

                return glance;
            };

            getAmountAndGlance = function(memberInfo, clientNumber) {
                var
                    amountPromise = services.dpsext.spendingAccountAmount().fetch(
                        memberInfo,
                        clientNumber
                    ),

                    glancePromise = services.dpsext.spendingAccountGlance().fetch(
                        memberInfo,
                        clientNumber,
                        30
                    ),

                    amountAndGlancePromiseAll = $q.all({ amount: amountPromise, glance: glancePromise });


                return amountAndGlancePromiseAll.then(
                    function(response) {
                        var
                            glance = _parseGlanceResponse(response.glance.data.repGetAccountsAtAGlanceReply),
                            amount = _parseAmountResponse(response.amount.data.repGetClaimAmountReply);

                        return { amount: amount, glance: glance, memberInfo: memberInfo };
                    },
                    function(err) {
                        console.error('$q.all({ amount: amountPromise, glance: glancePromise }) failed with error', err);
                        return amountAndGlancePromiseAll;
                    }
                );
            };


            getAllAmountsAndGlances = function() {
                var memberInfoPromise = services.rbsmbl.memberInfo().fetch();

                return memberInfoPromise.then(
                    function(response) {
                        var
                            memberInfo = response.data.payload,
                            clientNumberList = services.rbsmbl.memberInfo().spendingAccountClients(memberInfo),
                            allPromises = {};

                        clientNumberList.forEach(function(clientNumber) {
                            allPromises[clientNumber] = getAmountAndGlance(memberInfo, clientNumber);
                        });

                        var amountsAndGlancesPromisesAll = $q.all(allPromises);

                        return amountsAndGlancesPromisesAll.then(
                            function(responses) {
                                return responses;
                            },
                            function(err) {
                                console.error('allPromises failed in getAllAmountsAndGlances', err);
                                return amountsAndGlancesPromisesAll;
                            }
                        );
                    },
                    function(err) {
                        console.error('memberInfo.fetch failed in getAllAmountsAndGlances', err);
                        return memberInfoPromise;
                    }
                );
            };


            getSpendingAccount = function(clientId, claimNumber) { // clientId (formerly known as the clientNumber because wot?
                // TODO: Figure out if we're gonna use the claimNumber or the dates to ensure claims (cont'd below)
                // TODO: can only be paid from contemporary spending accounts
                var memberInfoPromise = services.rbsmbl.memberInfo().fetch();

                return memberInfoPromise.then(
                    function(response) {
                        var amountAndGlancePromise = getAmountAndGlance(response.data.payload, clientId);

                        return amountAndGlancePromise.then(
                            function(result) {
                                var
                                    glance = result.glance,
                                    accountDisplayName;

                                if (glance && Number(glance.accountListCount) > 1) {
                                    accountDisplayName = 'Spending Account';
                                }
                                else if (glance && Number(glance.accountListCount) === 1) {
                                    accountDisplayName = glance.accountList.accountInfo[0].accountDisplayName;
                                }
                                else {
                                    accountDisplayName = 'No Spending Accounts Found';
                                }

                                return {
                                    accountDisplayName: accountDisplayName
                                };
                            },
                            function(err) {
                                console.error('getAmountAndGlance failed in getSpendingAccount', err);
                                return amountAndGlancePromise;
                            }
                        );
                    },
                    function(err) {
                        console.error('memberInfo.fetch failed with error', err);
                        return memberInfoPromise;
                    }
                );
            };
 
            hasSpendingAccount = function(allAmountsAndGlances) {
                var allAG = allAmountsAndGlances || {};

                return Object.keys(allAG).some(
                    function(client) {
                        if (!(allAG[client] instanceof Object)) {
                            return false;
                        }

                       return (allAG[client].amount instanceof Object && (Number(allAG[client].amount.accountListCount) > 0))
                        || (allAG[client].glance instanceof Object && (Number(allAG[client].glance.accountListCount) > 0));
                    }
                );
            };

            getSpendingAccountList = function() {
                var getAccounts = getAllAmountsAndGlances();
                return getAccounts.then(
                    function(response) {
                        var
                            accountListsByClientNumber = {},
                            accountList = [],
                            glance,
                            glanceAccountList,
                            glanceAccounts;

                        for (var clientNumber in response) {
                            if (response.hasOwnProperty(clientNumber)) {
                                glance = response[clientNumber].glance;

                                glanceAccountList = glance instanceof Object
                                                  ? glance.accountList
                                                  : {};

                                glanceAccounts = glanceAccountList.accountInfo || [];

                                accountListsByClientNumber[clientNumber] = (function(clientNumber) {
                                    return glanceAccounts.map(function (account) {
                                        var
                                            currentBalanceFromAmount,
                                            clientResponse = response[clientNumber],

                                            clientAmountObject = clientResponse.amount instanceof Object
                                                               ? clientResponse.amount
                                                               : {},

                                            clientAccountListObject = clientAmountObject.accountList instanceof Object
                                                                    ? clientAmountObject.accountList
                                                                    : {},

                                            amounts = clientAccountListObject.account || [],
                                            amount,
                                            len,
                                            i;

                                        for (i = 0, len = amounts.length; i < len; ++i) {
                                            amount = amounts[i];

                                            if (amount.accountTypeCode.toLowerCase() === account.accountType.toLowerCase()) {
                                                currentBalanceFromAmount = amount.currentBalance;
                                                break;
                                            }
                                        }

                                        return {
                                            accountDisplayName: account.accountDisplayName,
                                            accountDisplaySeq: Number(account.accountDisplaySeq),
                                            transactionCount: account.transactionCount,
                                            currentBalance: currentBalanceFromAmount
                                        };
                                    });
                                }(clientNumber));

                                // TODO: figure out if at some point these should be filtered by a clientNumber. If so, that can happen earlier
                                accountList = accountList.concat(accountListsByClientNumber[clientNumber]);
                            }
                        }
                        // TODO: Figure out if we need this level of granularity for anything at all
                        // console.log('accountListsByClientNumber', accountListsByClientNumber);

                        return accountList;
                    }
                );
            }


            return {
                getAmountAndGlance: getAmountAndGlance,
                getAllAmountsAndGlances: getAllAmountsAndGlances,
                getSpendingAccount: getSpendingAccount,
                hasSpendingAccount: hasSpendingAccount,
               getSpendingAccountList:getSpendingAccountList
            };
        }
    ]);
    bootstrap.directive('spendingAccountSummary', function() {

        return {
            restrict: 'A',
            replace: true,
            template: require('articles/spendingAccountSummary.html'),

            scope: {},

            controller: ['$scope', 'spendingAccountService', 'coremetrics', function($scope, spendingAccountService, coremetrics) {

                $scope.heading = 'Spending Accounts';
                $scope.viewState = 'loading';

                /*Emit Click for listener*/
                $scope.spaWidgetSummaryArrowCoremetrics = function(){
                    $scope.$emit('SPAWidgetArrowClick');
                };

                spendingAccountService.getSpendingAccountList().then(
                    function(accountList){
                        $scope.accountList = accountList;
                        $scope.viewState = 'success';
                    },
                    function(err) {
                        $scope.viewState = 'error';
                        console.error('getAccounts failed with error', err);
                    }
                );

            }]
        };
    });

    bootstrap.directive('spendingAccountBalance', function() {

        return {
            restrict: 'A',
            replace: true,
            template: require('articles/spendingAccountBalance.html'),
            scope: {},
            controller: ['$scope', 'spendingAccountService', 'session', 'sessionData', 'brand','services','$cookies', function($scope, spendingAccountService, session, sessionData, brand, services,$cookies) {
                var currentPlan = services.rbsmbl.memberInfo().getPortalSelectedPlan(sessionData.memberInfo);
                var clientNumber = $cookies.get("mbrClientNumber");
                var theDate = new Date().getFullYear() + "-12-31";
                $scope.isSelectAccount = false;
                services.rbsmbl.vendorDetails().getVendorDetails(clientNumber, theDate, currentPlan.groupNumber).then(function (response) {
                    var vendorDetails = (response
                    && response.data
                    && response.data.payload)
                        ? response.data.payload : [];
                    for ( var i=0; i < vendorDetails.length; i++) {
                        if (vendorDetails[i].vendorName === "SelectAccount") {
                            $scope.isSelectAccount = true;

                        }
                    }
                    $scope.shouldShow = !session.data.blueEdgeDentalIndv && !sessionData.spendingAccountBlackoutIndicator? true:false;
                    $scope.isWYBCBS = ((brand.current.sharedBrandCode).toLowerCase() === 'wybcbs') ? true : false;
                    $scope.isWybcbsSelectAccount = $scope.isSelectAccount && $scope.isWYBCBS? true : false;
                    if ($scope.shouldShow && !$scope.isWybcbsSelectAccount) {
                        $scope.heading = 'SPENDING ACCOUNT BALANCE';
                        $scope.viewState = 'loading';

                        /*Emit Click for listener*/
                        $scope.spaWidgetSummaryArrowCoremetrics = function () {
                            $scope.$emit('SPAWidgetArrowClick');
                        };

                        var accountListPromise = spendingAccountService.getSpendingAccountList();

                        accountListPromise.then(
                            function (accountList) {
                                $scope.accountList = accountList;
                                $scope.shouldShow = accountList.length;
                                $scope.viewState = 'success';
                            },
                            function(err) {
                                $scope.viewState = 'error';
                                //console.error('getSpendingAccountList failed with error', err);
                                return accountListPromise;
                            }
                        );
                    }
                }, function (error) {
                    $scope.isSelectAccount = false;
                });




            }]
        };
    });
}